export default __webpack_public_path__ + "static/media/Thumb_Top_04.0941254b.png";